import { NgModule } from '@angular/core';
import { ThemeEmitterComponent } from './theme-emitter.component';

@NgModule({
    declarations: [ThemeEmitterComponent],
    imports     : [],
    exports     : [ThemeEmitterComponent],
    providers   : [],
})
export class ThemeEmitterModule {}
